import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase'
import { ReferentialRepository } from '@/core/infrastructure/repositories/referential/ReferentialRepository.ts'
import { FetchAllAxisUseCase } from '@/core/useCases/referential/FetchAllAxisUseCase.ts'
import { FetchAxisByIdUseCase } from '@/core/useCases/referential/FetchAxisByIdUseCase.ts'

export class ReferentialModule extends ModuleBase {
  initialize(): void {
    this.initializeCore()
  }

  private initializeCore(): void {
    const referentialRepository = new ReferentialRepository()

    this.registerRepository(ReferentialRepository, referentialRepository)

    const fetchAllAxisUseCase = new FetchAllAxisUseCase(referentialRepository)
    this.registerUseCase(FetchAllAxisUseCase, fetchAllAxisUseCase)

    const fetchAxisByIdUseCase = new FetchAxisByIdUseCase(referentialRepository)
    this.registerUseCase(FetchAxisByIdUseCase, fetchAxisByIdUseCase)
  }
}
